import React, { useContext, useState, useEffect } from 'react';
import { FormWrapper, 
         ButtonStyled,
         ButtonTextStyled } from './styles';
import { ContentContext } from '../../context/ContentContext';
import { validateEmail } from '../helpers/functions';
import { IoClose } from "react-icons/io5";
import { CircularProgress } from '@mui/material';
import { useLocation } from 'react-router-dom';

const FormLogin = (props) => {
    
    let location = useLocation();

    const { dataSaved, 
            setDataSaved,
            showLogin,
            setShowLogin,
            setShowRegistro,
            setShowForgot,
            setScope,
            trigger,
            setOpenSnackbar,
            setSnackbarMessage,
            setSnackbarVariant } = props;

    const { provinces,
            forgot } = useContext(ContentContext);

    const [ formData, setFormData ] = useState({ email: { value:"", error: false, mandatory: true }, });
                                                 
    const [ isLoading, setIsLoading ] = useState(false);

    const handleOnChanceForm = (e, name) => {
        
        let formData_update = {...formData};

        formData_update[name].value = e.target.value;

        switch (name) {
            case "name":
                //formData_update[name].value = e.target.value;
                break;
        
            default:
                break;
        }

        setFormData(formData_update);

    }
    console.log("location", location)
    const handleSaveData = () => {

        setIsLoading(true);
        let haveError = false;

        let formDataValidate = {...formData};
        Object.keys(formDataValidate).map((field) => {
            
            if(formDataValidate[field].mandatory){
                if(!formDataValidate[field].value.length){
                    haveError = true;
                    formDataValidate[field].error =  true;
                }else{
                    formDataValidate[field].error =  false;
                }
            }

            if(field === "email"){
                if(!validateEmail(formDataValidate[field].value)){
                    haveError = true;
                    formDataValidate[field].error =  true;
                }else{
                    formDataValidate[field].error =  false;
                }
                console.log(validateEmail(formDataValidate[field].value));
            }
            
            
        })
        setFormData(formDataValidate);

        if(!haveError){
            const payload = {email: formData.email.value, pathname: location.pathname};
            const response = forgot(payload);
            console.log("response" ,payload);
            //return null;
            response.then(res => {
                setIsLoading(false);
                if(res.data.success){

                    setOpenSnackbar(true);
                    setSnackbarMessage("Te enviamos un E-Mail con los pasos a seguir para cambiar tu contraseña.");
                    setSnackbarVariant("success");

                    setShowLogin(false);       
                    setShowRegistro(false); 

                    resetForm();
                    //setShowForgot(false);
                    //setScope(null);
                    //trigger();
                }else{

                    setOpenSnackbar(true);
                    setSnackbarMessage("Los datos ingresador no coinciden con un usuario registrado.");
                    setSnackbarVariant("error");

                }
                console.log("🚀 sendLogin", res)
            })
        }else{
            setIsLoading(false);
        }
        console.log("formData", formData);

    }

    const handleClose = () => {
        setScope(null);
    }

    const handleGotoLogin = () => {
        setShowLogin(true);
        setShowRegistro(false);
        setShowForgot(false);
    }

    const resetForm = () => {

        let formReset = {...formData};
        Object.keys(formReset).map((field) => {
            formReset[field].value = "";
            formReset[field].error = false;
        })
        setFormData(formReset);

    }

    useEffect(() => {
      console.log("provinces", provinces)
    
      return () => {}
    }, [provinces])
    

    return (
        <FormWrapper>
            <div className='inner'>
                <div className='bt_close' onClick={handleClose}>
                    <p><IoClose /></p>
                </div>
                <div className='fields'>
                    <div className='field'>
                        <label>E-Mail {formData.email.mandatory ? "*" : ""}</label>
                        <input 
                            className={`${formData.email.error ? " error" : ""}`}
                            type="text" 
                            value={formData.email.value} 
                            onChange={(e) => handleOnChanceForm(e, "email")}
                        />
                    </div>
                </div>

                <div className='aclaration_asterix'>Los campos con * son obligatorios</div>
                
                <div className='actions'>
                    {!isLoading ? 
                        <ButtonStyled onClick={() => handleSaveData()}>
                            Enviar
                        </ButtonStyled>
                    :
                        <div className='loader'>
                            <CircularProgress />
                        </div>
                    }
                    <ButtonTextStyled onClick={() => handleGotoLogin()}>
                        INGRESAR
                    </ButtonTextStyled>
                </div>
            </div>
        </FormWrapper>
    );
};

export default FormLogin;